import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventPullToRefresh]'
})
export class PreventPullToRefreshDirective {
  private startY = 0;

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    this.startY = event.touches[0].clientY;
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent): void {
    if (window.scrollY === 0 && event.touches[0].clientY > this.startY) {
      event.preventDefault();
    }
  }
}
